import React from 'react';
const tiers = [{
  numeral: 'I',
  name: 'Vera Access',
  note: 'Opening Soon',
  body: "The Vera training and nutrition methods as a self-guided membership. Programming updates on its own schedule and a new resource arrives each month. You run it yourself, and it's built so you can.",
  link: false
}, {
  numeral: 'II',
  name: 'Vera Standard',
  note: 'Enrolling for September',
  body: 'Your program, delivered. Every two weeks a coach reviews your data and you get clear direction on what to do next, with a written pulse on the off weeks and a one-page trend report at the end of each month.',
  link: true
}, {
  numeral: 'III',
  name: 'Vera Method',
  note: 'Enrolling for September',
  body: 'One-on-one with Ashley. Two private calls a month, your complete system built and managed for you, and support between calls answered by Ashley. The plan is the easy part. Method works on how you run it.',
  link: true
}];
export function TheWork() {
  return <section id="tiers" className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto pt-24 pb-8 border-t border-ink/10" data-id="element-70" data-mp="26598sr5l71d3">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-24" data-id="element-71" data-mp="2b3ap54bmomkv">
        <div className="md:col-span-3" data-id="element-72" data-mp="2fxewvpspwyn0">
          <div className="label text-graphite/60" data-id="element-73" data-mp="2fyg9hypdtt6u">The Work</div>
        </div>
        <p className="md:col-span-6 font-sans font-light text-lg md:text-xl text-graphite/80 leading-relaxed" data-id="element-74" data-mp="2kudq864k51k5">
          Every Vera client runs on the same system: training and nutrition
          built on the Vera methods, adjusted as your life changes. What
          changes from tier to tier is how much of it we run for you.
        </p>
      </div>

      <div data-id="element-75" data-mp="217pjmw7cp46d">
        {tiers.map(tier => <div key={tier.name} className="py-14 md:py-16 border-t border-ink/15 grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-8" data-id="element-76" data-mp="218irk0i1pzq3">
            <div className="tier-numeral text-2xl md:col-span-1 md:pt-1" data-id="element-77" data-mp="3clbgz4nd6c2z">
              {tier.numeral}
            </div>
            <div className="md:col-span-4" data-id="element-78" data-mp="1dg1m57szt8n7">
              <h3 className="text-3xl md:text-4xl" data-id="element-79" data-mp="18ii6q4kk6pto">{tier.name}</h3>
              <div className="label text-graphite/50 mt-4" data-id="element-80" data-mp="18i8kms2mx2t9">{tier.note}</div>
            </div>
            <div className="md:col-span-6 md:col-start-7" data-id="element-81" data-mp="1mhhyhl3dbku2">
              <p className="font-sans font-light text-base md:text-lg text-graphite/80 leading-relaxed" data-id="element-82" data-mp="1hiyalf57ryz2">
                {tier.body}
              </p>
              {tier.link && <a href="https://form.jotform.com/262155460714050" target="_blank" rel="noopener noreferrer" className="cta mt-8" data-id="element-83" data-mp="psackbyu79pm">
                  Request a Place
                </a>}
            </div>
          </div>)}
      </div>
    </section>;
}